import { render } from "./EditMaterialModal.vue?vue&type=template&id=4e7e8b10&scoped=true"
import script from "./EditMaterialModal.vue?vue&type=script&lang=js"
export * from "./EditMaterialModal.vue?vue&type=script&lang=js"

import "./EditMaterialModal.vue?vue&type=style&index=0&id=4e7e8b10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e7e8b10"]])

export default __exports__